export default __webpack_public_path__ + "static/media/Rmom.7263ac37.svg";